import type { HttpClient } from '../../../types/api';
import type { APIResponse } from '../../../types/api';

export type PostNewsLetterParams = {
  permission: number;
};

export type PostNewsLetterResponse = APIResponse<{
  permission: number;
}>;

export const postNewsLetter = async (params: PostNewsLetterParams, httpClient: HttpClient) => {
  return await httpClient.post<PostNewsLetterResponse>('user/v1/newsletter', {
    body: JSON.stringify({
      permission: params.permission,
    }),
  });
};
